import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import vuetify from './plugins/vuetify';
import VueMarkdown from 'vue-markdown'
import App from './App.vue'
import './main.scss'
import '@mdi/font/css/materialdesignicons.min.css'
import axios from "axios";
import moment from "moment";
import PortalVue from 'portal-vue'
import VueTheMask from 'vue-the-mask'
import {Centrifuge} from "centrifuge";
import ConfirmDialog from "@/componentsV2/base/ConfirmDialog.vue";
import printJS from "print-js";
//import Pay from "@/plugins/pay";

moment.locale('ru');
Vue.use(Vuex)
Vue.use(PortalVue)
Vue.use(VueTheMask)
Vue.component('vue-markdown', VueMarkdown);
Vue.use(require('vue-cookie'));

Vue.filter('dateYears', function (v){
  console.warn('filter dateYears deprecated');
  if (v==null) return '';
  if (v.length!==10) return '';
  return '('+moment(v, 'YYYY-MM-DD HH:mm:ss').fromNow(true)+')';
});
Vue.filter('date', function (v){
  console.warn('filter date deprecated');
  if(Vue.prototype.$tools.isEmpty(v)) return '';
  return moment(v, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY')
});

//Vue.prototype.$pay = new Pay();
Vue.prototype.$apiCache = [];

// global variables
Object.defineProperty(Vue.prototype, '$mainColor', {
  get() {
    return !this.$vuetify.theme.dark
      ? process.env.VUE_APP_COLOR
      : 'rgb(40 40 40)'
  }
})
Vue.prototype.$inactiveStatuses = ['notReady','cancel','rejected'];
Vue.prototype.$activeStatuses = ['pre','confirmed','ready','active','complete','move','self'];

Vue.prototype.$tools = {
  debounce(callback, time=1000, name=null){
    if(name===null)
      name = 'main';
    name = 'debounceTimer_'+name;
    if(typeof window[name]!=='undefined')
      clearTimeout(window[name]);
    window[name] = setTimeout(()=>{
      callback();
    },time);
  },
  throttle(callback, time=1000, name=null){
    if (name === null)
      name = 'main';
    name = 'throttleTimer_' + name;
    if (typeof window[name] !== 'undefined') return;
    callback();
    window[name] = setTimeout(() => {
      delete window[name];
    }, time);
  },
  findById(arr, v){
    let s = '';
    arr.forEach((v1)=>{
      if (v1.id===v)
        s = v1;
    });
    return s;
  },
  isDefined(v) {
    return typeof v != 'undefined';
  },
  isEmpty(v) {
    if (typeof v === 'undefined') return true;
    if (v === null) return true;
    return v.length === 0;
  },
  isBlank(v) {
    if(typeof v==='string')
      return (v+'').replace(/\s/g, '').length === 0
    return Vue.prototype.$tools.isEmpty(v);
  },
  parseNumber(v, decimal=2) {
    if (typeof v === 'undefined') return 0;
    if (v==='') return 0;
    if (v===null) return 0;
    if (isNaN(v)) return 0;
    v = v+'';
    v = parseFloat(v)
    v = parseFloat(v.toFixed(decimal))
    return v===0 ? 0 : v;
  },
  notNull(obj, path) {
    let a = path.split('.').reduce((obj, prop) => {
      return obj && obj[prop] ? obj[prop] : null;
    }, obj)
    return a!==null
  },
  mergeUniqById(arr1, arr2) {
    let arr10 = [];
    arr1.filter(v=>v!==null).forEach(v=>{arr10[v.id] = v;});
    arr2.filter(v=>v!==null).forEach(v=>{arr10[v.id] = v;});
    let arr11 = [];
    arr10.forEach(v=>{arr11.push(v)});
    return arr11;
  },
  nl2br(v) {
    return String(v).replace(/([^>])\n/g, '$1<br/>')
  },
  dump(v) {
    console.log(v)
    return v;
  },
  date(v){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    return moment(v, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY')
  },
  years(v){// округляет (критично для 9 месяцев) dateYears показывает возраст с месяцами без округления
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    return moment(v, 'YYYY-MM-DD HH:mm:ss').fromNow(true);
  },
  dateText(v){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    if (typeof v == 'object') return moment(v).format('dddd, DD MMMM');
    return moment(v, 'YYYY-MM-DD').format('dddd, DD MMMM');
  },
  dateTime(v, addText=true){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    return moment(v, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY'+(addText ? ' в':'')+' HH:mm')
  },
  dateFull(v){
    return moment(v, 'YYYY-MM-DD HH:mm:ss').format('dddd, DD MMMM YYYY')
  },
  dateTimeFormat(v, toFormat, fromFormat='YYYY-MM-DD HH:mm:ss', addMinutes=0){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    let r = typeof fromFormat==='undefined' || fromFormat===null ?  moment(v) : moment(v, fromFormat);
    if(v==='now')
      r = moment();
    if(addMinutes!==0)
      r = r.add(addMinutes, 'minutes');
    return r.format(toFormat);
  },
  dateFormat(v, beauty=true, addMinutes=0){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    let r = v==='now' ? moment() : moment(v, 'YYYY-MM-DD HH:mm:ss');
    if(addMinutes!==0)
      r = r.add(addMinutes, 'minutes');
    if(beauty){
      if(moment().diff(r, 'days')<1)
        return r.format('HH:mm');
      else if(moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(1, 'day').format('DD.MM.YYYY')===r.format('DD.MM.YYYY'))
        return 'вчера '+r.format('HH:mm');
    }
    return r.format('DD.MM.YYYY HH:mm');
  },
  dateStringToAtom(dateString){
    return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format();
  },
  secondsToTime(v){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    return moment().startOf('day').seconds(v).format('mm:ss');
  },
  dateTimeFull(v){
    if(Vue.prototype.$tools.isEmpty(v)) return '';
    return moment(v, 'YYYY-MM-DD HH:mm:ss').format('dddd, DD.MM.YYYY в HH:mm')
  },
  isDateUnder(date, v, format=''){
    if(Vue.prototype.$tools.isEmpty(date)) return false;
    return moment().diff(moment(date, format), 'years')<v;
  },
  time(v){
    return moment(v, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
  },
  price(v, emptyStr=null){
    let v1 = parseFloat(v);
    if(isNaN(v1)) return emptyStr===null ? '' : emptyStr;
    let v2 = v1.toFixed(2);
    if(emptyStr!==null && v2==='0.00')
      return emptyStr;
    return v2.replace(/\d(?=(\d{3})+\.)/g, '$&,')+' Р';
  },
  percent(v1, v2, emptyStr=0, onlyValue=false){
    if(Vue.prototype.$tools.isEmpty(v1) || Vue.prototype.$tools.isEmpty(v2))
      return emptyStr+(onlyValue ? '' : ' %');

    let v10 = parseFloat(v1).toFixed(2);
    let v20 = parseFloat(v2).toFixed(2);

    if(v10==='0.00' || v20==='0.00')
      return emptyStr+(onlyValue ? '' : ' %');

    let v30 = ((v10/v20)*100).toFixed(0);
    return v30+(onlyValue ? '' : ' %');
  },
  arrayGen(arr, addFields){
    arr.forEach((v, k)=>{
      arr[k] = Object.assign(v, addFields(v));
    });
    return arr;
  },
  openUrl(url, newWindow=false){
    if(newWindow===true)
      window.open(url, "_blank")
    else
      window.location = url
  },
  copy(v){
    return JSON.parse(JSON.stringify(v))
  },
  equals(a,b){
    return JSON.stringify(a)===JSON.stringify(b)
  },
  key(a=null){
    const str = a===null ? '0' : JSON.stringify(a);
    let hash = 0;
    for (let i = 0; i < str.length; i++)
      hash = str.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
    return hash >>> 0;
  },
  hash(v=null, successCallback){
    const str = JSON.stringify(v);
    const encoder = new TextEncoder();
    const data = encoder.encode(str);

    crypto.subtle.digest('SHA-256', data).then(hashBuffer=>{
      const hashArray = Array.from(new Uint8Array(hashBuffer));

      successCallback(
        hashArray
          .map(b => b.toString(16).padStart(2, '0'))
          .join('')
      );
    })
  },
  filterByGlobalState(arr, name){
    if(typeof localStorage['globalState_'+name]!=='undefined') {
      let arr1 = JSON.parse(localStorage['globalState_'+name]);
      if(arr1.length>0){
        arr1.forEach((v)=>{
          v.id = parseInt(v.id);
        });
        return arr.filter(v=>v.comBranch===null || arr1.some(v1 =>v.comBranch.id===v1.id))
      }
    }
    return arr;
  },
  storageSet(key, value=null){
    if(Vue.prototype.$tools.isEmpty(value)){
      localStorage.removeItem(key);
    } else {
      localStorage[key] = typeof value==='object' ? JSON.stringify(value) : value;
    }
  },
  storageGet(key, valueDefault=null){
    if(typeof localStorage[key]==='undefined')
      return valueDefault;

    const value = localStorage[key];
    try {
      const parsed = JSON.parse(value);
      if(typeof parsed === 'object' && parsed !== null)
        return parsed;
      // eslint-disable-next-line no-empty
    } catch (e){}
    return value;
  },
  storageArrayAdd(key, value, maxValues=50){
    let arr = typeof localStorage[key]==='undefined' ? [] : JSON.parse(localStorage[key]);
    value.sid = Vue.prototype.$tools.randomString();
    value.created = moment().format('YYYY-MM-DD HH:mm:ss');
    arr.push(value);
    arr = arr.sort((a,b)=>a.created===b.created ? 0 : a.created>b.created ? -1 : 1)
    arr = arr.slice(0, maxValues);
    localStorage[key] = JSON.stringify(arr);
  },
  storageArrayRemove(key, valueSid){
    let arr = typeof localStorage[key]==='undefined' ? [] : JSON.parse(localStorage[key]);
    arr = arr.filter(v=>v.sid!==valueSid);
    if(arr.length===0){
      localStorage.removeItem(key);
    } else {
      localStorage[key] = JSON.stringify(arr);
    }
    return Vue.prototype.$tools.storageArrayGet(key)
  },
  storageArrayGet(key){
    if(typeof localStorage[key]==='undefined')
      return [];
    return JSON.parse(localStorage[key]);
  },
  randomString(length=8) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  },
  token() { //16788864001234567A - 18 length
    return Math.floor(Date.now() / 1000)+Vue.prototype.$tools.randomString(8);
  },

  pageVisibleInit(){
    if(typeof window.pvcTimer!=='undefined')
      clearTimeout(window.pvcTimer);
    window.pvcTimer = setInterval(()=>{
      if(document.visibilityState==='visible')
        window.pvcLastTime = moment().unix();
      window.pvcAllow = moment().unix()-window.pvcLastTime<60
    },1000);
  },
  pageVisibleCallback(acceptCallback=null, rejectCallback=null){
    let pvcAllow = typeof window.pvcLastTime=='undefined' ? true : window.pvcAllow

    if(document.visibilityState==='visible' || pvcAllow){
      if(acceptCallback!==null){
        Vue.prototype.$tools.debounce(()=>{
          acceptCallback();
        }, 500, 'pageVisible');
      }
    } else {
      if(rejectCallback!==null)
        rejectCallback();
    }
  },

  arrSum(arr, field){
    let r = 0;
    arr.forEach(v=>{
      r+=parseFloat(v[field]);
    });
    return r;
  },
  timeFormatter($event) {
    let t = $event.target.value
    let exclude = ['3','4','5','6','7','8','9']
    if (t.length==1&&exclude.includes(t)) {
      return $event.target.value = ''
    }
    else {
      let str = t.substr(0,5).replace(':','').split('')
      if (t.length >= 3) {
        str.splice(2, 0, ':')
        let t = str.join('')

        return $event.target.value = t
        
      }
    }  
  },
  capitalizeName(str) {
    if (!str || typeof str !== 'string') return '';

    const parts = str.trim().split(' ');
    if (parts.length === 0) return '';

    const formattedFirstPart = parts[0]
      .split('-')
      .map(subPart => subPart[0].toUpperCase() + subPart.slice(1).toLowerCase())
      .join('-');

    const restParts = parts.slice(1).join(' ');

    return formattedFirstPart + (restParts ? ' ' + restParts : '');
  },
  getGenderBySecondName(patronymic) {
      if (!patronymic || typeof patronymic !== 'string') {
          return 'male';
      }

      const patronymicLower = patronymic.toLowerCase().trim();

      // Проверка мужских окончаний (-ович, -евич, -ич)
      if (patronymicLower.endsWith('ович') || 
          patronymicLower.endsWith('евич') || 
          patronymicLower.endsWith('ич')) {
          return 'male'; // male (мужской)
      } 
      // Проверка женских окончаний (-овна, -евна, -ична, -инична)
      else if (patronymicLower.endsWith('овна') || 
              patronymicLower.endsWith('евна') || 
              patronymicLower.endsWith('ична') || 
              patronymicLower.endsWith('инична')) {
          return 'female'; // female (женский)
      } 
      // Если не удалось определить
      else {
          return 'male';
      }
  },
  priceFormatter(str){
    if (typeof str === 'string') {
      let replacedStr = str.replace(',', '.');
      return replacedStr;
    } else {
      return str;
    }
  },
  copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  },
  dateYears(date, format = 'DD.MM.YYYY') {
    const currentDate = moment(new Date());
    const birthDate = moment(date, format);
  
    if (!birthDate.isValid()) return '';
  
    const years = currentDate.diff(birthDate, 'years');
    const months = currentDate.diff(birthDate.clone().add(years, 'years'), 'months');
  
    function getAgeText(age) {
      if (age % 10 === 1 && age % 100 !== 11) {
        return "год";
      } else if (age % 10 >= 2 && age % 10 <= 4 && (age % 100 < 10 || age % 100 >= 20)) {
        return "года";
      } else {
        return "лет";
      }
    }
  
    function getMonthText(months) {
      if (months === 1) {
        return "месяц";
      } else if (months >= 2 && months <= 4) {
        return "месяца";
      } else {
        return "месяцев";
      }
    }
  
    return `${years} ${getAgeText(years)} ${months} ${getMonthText(months)}`;
  },  
  dateYearsSimple(date,format='DD.MM.YYYY'){
    const currentDate = moment(new Date());
    const birthDate = moment(date, format);

    const duration = moment.duration(currentDate.diff(birthDate));
    const years = duration.years();

    if (birthDate==null) return '';
    if (!birthDate.isValid()) return '';

    let text = '';
    if (years % 10 === 1 && years % 100 !== 11)
      text = 'год';
    else if (years % 10 >= 2 && years % 10 <= 4 && (years % 100 < 10 || years % 100 >= 20))
      text = 'года';
    else
      text = 'лет';

    return years+' '+text;
  },
  truncateText(text, maxLength = 200) {
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.slice(0, maxLength - 3).trim() + '...';
    }
  },
  textHighlight(text, search){
    let pos = text.toLowerCase().indexOf(search.toLowerCase());
    if (pos===-1) return text;
    return text.substr(0, pos) +
      '<span class="yellow">'+ text.substr(pos, search.length)+'</span>' +
      text.substr(pos + search.length);
  },
  pageHeight(){
    return window.innerHeight-(18 * 2)-48;
  },

  misDesktopStatus(callback){
    axios.get('http://localhost:3035/api/status/')
      .then(() =>{
        callback(true);
      })
      .catch((e) =>{
        callback(false);
        console.log(e);
      });
  },
  misDesktopOpenFile(fileUrl, fileName, uploadUrl, uploadParams, success, error){
    axios.post('http://localhost:3035/api/file/', {
      fileUrl:fileUrl,
      fileName:fileName,
      uploadUrl:uploadUrl,
      uploadParams:uploadParams,
    })
      .then(() =>{
        if(success!==null) success();
      })
      .catch(() =>{
        if(error!==null) error();
      });
  },
  misDesktopKkmProxyStatus(callback){
    axios.get('http://localhost:3035/api/kkm_proxy/status/')
      .then(() =>{
        callback(true);
      })
      .catch((e) =>{
        callback(false);
        console.log(e);
      });
  },
  misDesktopKkmProxyRequest(successCallback, errorCallback){
    axios.get('http://localhost:3035/api/kkm_proxy/search/')
      .then((r) =>{
        successCallback(r.data);
      })
      .catch(() =>{
        errorCallback();
      });
  },

  //selects
  isSelectAll(items, itemsSelects){
    if(Vue.prototype.$tools.isEmpty(items)) return false;
    return items.length>0 && items.length===itemsSelects.length;
  },
  isSelectIntermidiate(items, itemsSelects){
    if(Vue.prototype.$tools.isEmpty(items)) return false;
    return items.length>0 && itemsSelects.length>0 && items.length!==itemsSelects.length;
  },
  isSelectSome(items, itemsSelects){
    if(Vue.prototype.$tools.isEmpty(items)) return false;
    return items.length>0 && itemsSelects.length>0;
  },
  isSelect(itemsSelects, item){
    return itemsSelects.filter(v=>v.id===item.id).length>0;
  },
  selectToggle(itemsSelects, item){
    if(this.isSelect(itemsSelects, item)) {
      itemsSelects.forEach((v, k)=>{
        if(v.id===item.id)
          itemsSelects.splice(k, 1)
      });
    } else {
      itemsSelects.push(item);
    }
  },
  selectAllToggle(items, itemsSelects){
    if(this.isSelectAll(items, itemsSelects)) {
      itemsSelects.splice(0);
    } else {
      itemsSelects.splice(0);
      items.forEach((v)=>{
        itemsSelects.push(v);
      });
    }
  },

  isFullPhone(v){
    if(Vue.prototype.$tools.isEmpty(v)) return false;
    return v.replace(/\D/g, '').length>=11
  },

  phoneFormat(v, removeFormat = false, onlyNumbers = false){
    if(Vue.prototype.$tools.isEmpty(v)) return '';

    if(onlyNumbers){
      v = v.replace(/\D/g, '');
      if(v[0]==='8')
        v = '7'+v.substring(1);
      return v;
    }

    if(removeFormat){
      v = v.replace(/\D/g, '');
      if(v[0]==='8')
        v = '+7'+v.substring(1);
      if(v[0]==='7')
        v = '+'+v;
      return v;
    }


    let p = '' + v;
    if(p.length===11){
      let m = p.match(/^(\d)?(\d{3})(\d{3})(\d{2})(\d{2})$/);
      if (m){
        let f = parseInt(p.substring(0, 1));
        if(f===8)
          f = 7;
        return ['+', f, ' (', m[2], ') ', m[3], '-', m[4], '-', m[5]].join('');
      }
    }
    return p;
  },
  phonesSearch(v){
    if(Vue.prototype.$tools.isEmpty(v)) return [];

    let matches = Array.from(v.matchAll(/(\d|,)/gm), m => m[0]);
    let index = 0;
    let phones = [];
    matches.forEach(v=>{
      if(v===',') index++;
      if(!Vue.prototype.$tools.isDefined(phones[index]))
        phones[index] = '';
      if(v!==',') phones[index] += v;
    })
    phones = phones.map(v=>Vue.prototype.$tools.phoneFormat(v, true))
    return phones;
  },
  phoneCallBrowser(phone){
    window.location.href='tel:'+phone
  },
  userFullName(user, short = false) {
    const { lastName = '', firstName = '', secondName = '' } = user || {};

    if (!short) {
      return [lastName, firstName, secondName].filter(Boolean).join(' ');
    } else {
      const firstInitial = firstName ? firstName[0] + '.' : '';
      const secondInitial = secondName ? secondName[0] + '.' : '';
      return [lastName, firstInitial, secondInitial].filter(Boolean).join(' ');
    }
  },
  downloadTableParserHeader($ref){
    let a = '\ufeff';
    let table = $ref.$el.querySelector('.v-data-table__wrapper table');
    const tableClone1 = table.cloneNode(true)
    tableClone1.querySelectorAll('thead th').forEach((th)=>{
      if(th.querySelector('span'))
        a +=th.querySelector('span').textContent.trim()+';'
    })
    a +='\n';
    return a;
  },
  downloadTableParserItems($ref){
    let a = '\ufeff';
    let table = $ref.$el.querySelector('.v-data-table__wrapper table');
    const tableClone1 = table.cloneNode(true)
    tableClone1.querySelectorAll('tbody tr').forEach((tr)=>{
      tr.querySelectorAll('td').forEach((td)=>{
        if (!td.querySelector('.v-input--checkbox')) {//exclude checkbox
          let v = td.textContent.replace('\n', '. ');

          //content for print
          if (td.hasAttribute('data-print')) {
            v  = td.getAttribute('data-print');
          }


          //v = v.replace('-', ' ');
          v = v.replace(/"/g, '');
          v = v.replace(/;/g, '');
          // v = v.replace(/\n/g, ' ');

          if(v.endsWith(" Р")){
            v = v.substring(0, v.length-2)
            v = v.replace(',', '');
            v = v.replace(/\./g, ',');
          }

          if (v.includes('\n')) {//если нужен перенос строки добавляем \n в data-print
            v = `"${v}"`;
          }

          v = v.trim();

          a +=v+';'
        }
      })
      a +='\n';
    })

    return a;
  },
  downloadAction(data, name='список'){
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data));
    element.setAttribute('download', name+'.csv');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },
  download($ref, name='список'){
    Vue.prototype.$tools.downloadAction(
      Vue.prototype.$tools.downloadTableParserHeader($ref)+Vue.prototype.$tools.downloadTableParserItems($ref),
      name
    );
  },

  getFileTypeByPath(filePath) {
    const extension = filePath.split('.').pop().toLowerCase();
    const mimeTypes = {
      'jpg': 'image',
      'jpeg': 'image',
      'png': 'image',
      'gif': 'image',
      'webp': 'image',
      'svg': 'image',
      'mp3': 'audio',
      'oga': 'audio',
      'wav': 'audio',
      'mp4': 'video',
    };
    return mimeTypes[extension] || 'unknown';
  },
  focusNext(nextRef, refs) {
    refs[nextRef].focus();
  },
  getContrastColor(hexColor) {
    if (!hexColor || typeof hexColor !== 'string') return '#000000';

    // Remove # and normalize to 6-digit format
    let hex = hexColor.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) return '#000000'; // invalid format

    // Use substring instead of substr
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  },
  sortByKey(items, key='name') {
    const collator = new Intl.Collator(['ru', 'en'], {
      sensitivity: 'base'
    });
    return items.sort((a, b) => collator.compare(a[key], b[key]));
  },
  uniqueByKey(items, key='id') {
    return [...new Map(items.map(item => [item[key], item])).values()];
  },
  print(urls, onProgress, onComplete, onError){
    const preload = function(urls, onProgress, onComplete, onError) {
      const total = urls.length;
      let completedCount = 0;
      const images = [];
      const blobUrls = []; // Массив для хранения blob URL

      // Проверка на localhost
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

      const currentHost = window.location.host;
      const currentProtocol = window.location.protocol;

      // Функция замены хоста (только для localhost)
      const replaceHostIfLocalhost = function(url) {
        if (!isLocalhost) return url;
        if (!url) return url;
        url = url.trim();
        if (url === '') return url;

        try {
          if (url.match(/^https?:\/\//i)) {
            const urlObj = new URL(url);
            return currentProtocol + '//' + currentHost + urlObj.pathname + urlObj.search + urlObj.hash;
          }
          if (url.startsWith('//')) {
            return currentProtocol + '//' + currentHost + url.substring(2);
          }
          // eslint-disable-next-line no-empty
        } catch(e) {

        }
        return url;
      };

      if (!total) {
        onComplete && onComplete([]);
        return;
      }

      // Храним прогресс каждого файла
      const fileProgress = new Array(total).fill(0);
      let lastReportedPercent = -1;

      // Функция обновления общего прогресса
      const updateProgress = function() {
        const sumProgress = fileProgress.reduce((sum, p) => sum + p, 0);
        const totalPercent = Math.round(sumProgress / total);

        // Отправляем прогресс только если он изменился
        if (totalPercent !== lastReportedPercent && onProgress) {
          lastReportedPercent = totalPercent;
          onProgress({
            percent: totalPercent,
            current: completedCount,
            total: total,
            fileProgress: [...fileProgress]
          });
        }
      };

      urls.forEach((originalUrl, index) => {
        const url = replaceHostIfLocalhost(originalUrl);

        // Используем XMLHttpRequest для отслеживания прогресса
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';

        // Отслеживаем прогресс загрузки
        xhr.onprogress = function(event) {
          if (event.lengthComputable) {
            // Процент загрузки текущего файла
            const percent = (event.loaded / event.total) * 100;
            fileProgress[index] = percent;
            updateProgress();

            // Детальный прогресс (опционально)
            if (onProgress) {
              onProgress({
                percent: Math.round(fileProgress.reduce((sum, p) => sum + p, 0) / total),
                currentFile: index + 1,
                currentFilePercent: Math.round(percent),
                loaded: event.loaded,
                total: event.total,
                url: url
              });
            }
          }
        };

        xhr.onload = function() {
          if (xhr.status === 200) {
            const blob = xhr.response;
            const objectUrl = URL.createObjectURL(blob);
            blobUrls[index] = objectUrl; // Сохраняем blob URL (НЕ УДАЛЯЕМ)

            const img = new Image();

            img.onload = function() {
              images[index] = img;
              completedCount++;
              fileProgress[index] = 100;
              updateProgress();

              // НЕ УДАЛЯЕМ blob URL здесь
              // URL.revokeObjectURL(objectUrl); - КОММЕНТИРУЕМ ИЛИ УДАЛЯЕМ

              if (completedCount === total) {
                // Возвращаем вместе с изображениями и blob URLs
                onComplete && onComplete({
                  images: images,
                  blobUrls: blobUrls,
                  total: total
                });
              }
            };

            img.onerror = function(err) {
              // При ошибке тоже не удаляем blob URL
              // URL.revokeObjectURL(objectUrl); - КОММЕНТИРУЕМ
              images[index] = null;
              completedCount++;
              fileProgress[index] = 100;
              updateProgress();

              if (completedCount === total) {
                onComplete && onComplete({
                  images: images,
                  blobUrls: blobUrls,
                  total: total
                });
              }

              onError && onError(err, url);
            };

            img.src = objectUrl;
          } else {
            images[index] = null;
            completedCount++;
            fileProgress[index] = 100;
            updateProgress();

            if (completedCount === total) {
              onComplete && onComplete({
                images: images,
                blobUrls: blobUrls,
                total: total
              });
            }

            onError && onError(new Error(`HTTP ${xhr.status}`), url);
          }
        };

        xhr.onerror = function(err) {
          images[index] = null;
          completedCount++;
          fileProgress[index] = 100;
          updateProgress();

          if (completedCount === total) {
            onComplete && onComplete({
              images: images,
              blobUrls: blobUrls,
              total: total
            });
          }

          onError && onError(err, url);
        };

        xhr.send();
      });
    };

    const cleanupBlobUrls = function(blobUrls) {
      if (!blobUrls || !blobUrls.length) return;

      blobUrls.forEach(blobUrl => {
        if (blobUrl) {
          URL.revokeObjectURL(blobUrl);
          //console.log('Blob URL очищен:', blobUrl);
        }
      });
    };

    preload(
      urls,
      (v)=>{
        Vue.prototype.$tools.throttle(()=>{
          onProgress(v);
        }, 100, 'printProgress');
      },
      (result)=>{
        const validBlobUrls = result.blobUrls.filter(url => url !== undefined && url !== null);

        printJS({
          printable: validBlobUrls,
          type: 'image',
          onLoadingEnd: () => {
            cleanupBlobUrls(validBlobUrls);
            onComplete();
          }
        })
      },
      onError
    );
  }
};

Vue.prototype.$permsCheck = function (
  perm,
  strongCheck = false,
  condition = null,
  deniedCallback = null
) {
  if (!perm) return true;
  if (condition && condition()) return true;
  if (this.$tools.isEmpty(this.$store.state.user)) return false;

  const userPerms = this.$store.state.user.perms
    ? this.$store.state.user.perms.split(',')
    : [];

  if (!userPerms.length) return false;

  if (strongCheck) { // если включена строгая проверка
    const allowed = userPerms.includes(perm);
    if (!allowed && deniedCallback) deniedCallback();
    return allowed;
  }

  function buildHierarchy(permission) {
    const parts = permission.split(/(?=[A-Z])/);
    const result = [];
    let current = '';

    for (const part of parts) {
      current += part;
      result.push(current);
    }

    return result;
  }

  const targetHierarchy = buildHierarchy(perm);

  const allowed = userPerms.some(userPerm => {
    const userHierarchy = buildHierarchy(userPerm);

    // точное совпадение
    if (userPerm === perm) return true;

    // есть родительский уровень (более общий доступ)
    if (targetHierarchy.includes(userPerm)) return true;

    // есть более детальный (дочерний) уровень
    if (userHierarchy.includes(perm)) return true;

    return false;
  });

  if (!allowed && deniedCallback) deniedCallback();

  return allowed;
};

Vue.prototype.$tabPermsCheck = function(tabs) {
    let tabSelected = null;
    tabs.forEach(tab=>{
      if(tab?.path===this.$router.currentRoute.path){
        tabSelected = tab;
      }
    });
    
    tabs = tabs.filter(tab => 
      this.$permsCheck(tab?.perm)||tab.perm===undefined
    );

    if (tabs.length>0){
      if (tabs.some(i=>i.name===tabSelected?.name)) { //если в разрешенных есть вкладка, которая задана по умолчанию
        if (tabSelected.path!==undefined&&tabSelected.path!==this.$router.currentRoute.path)// если путь не тот же, то переходим    
          this.$router.push(tabSelected.path)
        else // если нет, то возвращаем базовую вкладку
          return {tabs:tabs,tabSelected:tabSelected.name}
      } else { // если вкладка по умолчанию заблокирована ищем перовую доступную и если есть path и он не совпадает с текущим, то переходим
        if (tabs[0].path!==undefined&&tabs[0].path!==this.$router.currentRoute.path)    
          this.$router.push(tabs[0].path)
        else
          return {tabs:tabs,tabSelected:tabs[0].name}
      }
    } else { // если ничего не разрешено
      this.$router.push('/accessDenied/')
    }
}

Vue.prototype.$ws = {
  client:null,
  subscriptions:[],
  subscriptionListeners:[],
  connect(user, onConnected=null, onConnectError=null) {
    if(this.client!==null){
      if(onConnected!==null)
        onConnected();
      return
    }

    let client = new Centrifuge(
        'wss://'+process.env.VUE_APP_DOMAIN+'/ws/',
        {
          token: user.wsToken,
          recover: true
        }
    )
    client.on('error',(ctx)=>{
      console.error('[ws]',ctx)
      if(onConnectError!==null && ctx.type==='transport') onConnectError(ctx);
    })

    client
        .on('connected',(ctx)=>{
          console.log('[ws]','[connected]', ctx)
          if(onConnected!==null)
            onConnected();
        })
        .on('disconnected',(ctx)=>{
          console.log('[ws]','[disconnected]', ctx)
        })
        .on('subscribed',(ctx)=>{
          console.log('[ws]','[subscribed]',ctx.channel)
          if(!this.subscriptions.includes(ctx.channel)) this.subscriptions.push(ctx.channel);
          this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
            v.onSubscribed(ctx);
          })
        })
        .on('unsubscribed',(ctx)=>{
          if(ctx.code===105) {//already subscribed
            console.warn('[ws]','[unsubscribed]',ctx.channel, ctx)
          } else {
            console.log('[ws]', '[unsubscribed]', ctx.channel, ctx)
            this.subscriptionListeners.filter(v => v.channel === ctx.channel).forEach(v => {
              v.onUnsubscribed(ctx);
            })
            this.subscriptions = this.subscriptions.filter(v => v !== ctx.channel);
            this.subscriptionListeners = this.subscriptionListeners.filter(v => v !== ctx.channel);
          }
        })
        .on('join',(ctx)=>{
          console.log('[ws]','[join]', ctx)
          this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
            v.onJoin(ctx);
          })
        })
        .on('leave',(ctx)=>{
          console.log('[ws]','[leave]', ctx)
          this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
            v.onLeave(ctx);
          })
        })
        .on('publication', (ctx)=>{
          console.log('[ws]','[publication]', ctx)
          this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
            v.onPublication(ctx);
          })
        });

    client.connect()
    this.client = client;
  },
  disconnect() {
    if(this.client!==null){
      this.client.disconnect()
      this.client = null;
    }
  },
  subscribe(channelName, channelId, token=null){
    let channel = channelName+':#'+channelId;

    if(this.subscriptions.includes(channel))
      return

    this.subscriptions.push(channel);

    let sub = null;
    try {
      sub = this.client.newSubscription(
          channel,
          token===null ? {} : {token: token}
      );
      sub
          .on('subscribed',(ctx)=>{
            if(!this.subscriptions.includes(ctx.channel)) this.subscriptions.push(ctx.channel);
            this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
              v.onSubscribed(ctx);
            })
          })
          .on('unsubscribed',(ctx)=>{
            if(ctx.code!==105) {//already subscribed
              this.subscriptionListeners.filter(v => v.channel === ctx.channel).forEach(v => {
                v.onUnsubscribed(ctx);
              })
              this.subscriptions = this.subscriptions.filter(v => v !== ctx.channel);
              this.subscriptionListeners = this.subscriptionListeners.filter(v => v !== ctx.channel);
            }
          })
          .on('join',(ctx)=>{
            this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
              v.onJoin(ctx);
            })
          })
          .on('leave',(ctx)=>{
            this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
              v.onLeave(ctx);
            })
          })
          .on('publication', (ctx)=>{
            this.subscriptionListeners.filter(v=>v.channel===ctx.channel).forEach(v=>{
              v.onPublication(ctx);
            })
          });
      sub.subscribe();
    } catch (e) {
      console.error(e)
    }

    return sub
  },
  publish(sub, type, data){
    let body = {
      type:type,
      data:data,
    };
    sub.publish(body).then(()=>{
      console.log('[ws]','[publish]',sub.channel, body);
    }, (e)=>{
      console.error('[ws]','[publish]',sub.channel, body, e);
    });
  },
  unsubscribe(sub){
    if(sub!==null)
      sub.unsubscribe();
  },
  presence(sub, callback){
    if(!Vue.prototype.$tools.isEmpty(sub)){
      sub.presence()
          .then((ctx)=>{
            callback(ctx.clients);
          }, (e)=>{
            console.error(e)
          });
    }
  },
  addSubscribeListener(
      channelName, channelId,
      onSubscribed=null, onUnsubscribed=null, onJoin=null, onLeave=null, onPublication=null
  ){
    let id = Math.floor(Math.random() * 10000);
    let channel = channelName+':#'+channelId;

    this.subscriptionListeners.push({
      channel:channel,
      id: id,
      onSubscribed:(ctx)=>{
        console.info('[ws]','[subscribed]','[#'+id+']', ctx.channel);
        if(onSubscribed!==null) onSubscribed();
      },
      onUnsubscribed:(ctx)=>{
        console.info('[ws]','[unsubscribed]','[#'+id+']', ctx.channel);
        if(onUnsubscribed!==null) onUnsubscribed();
      },
      onJoin:(ctx)=>{
        console.info('[ws]','[join]','[#'+id+']', ctx);
        if(onJoin!==null) onJoin(ctx);
      },
      onLeave:(ctx)=>{
        console.info('[ws]','[leave]','[#'+id+']', ctx);
        if(onLeave!==null) onLeave(ctx);
      },
      onPublication:(ctx)=>{
        console.info('[ws]','[publication]','[#'+id+']', ctx.channel, ctx.data.type, ctx.data.data);
        if(onPublication!==null) onPublication(ctx.data);
      },
    });

    console.log('[ws]','[listenerAdded]','[#'+id+']');
    return id;
  },
  removeSubscribeListener(id){
    if(id===null) return
    this.subscriptionListeners = this.subscriptionListeners.filter(v=>v.id!==id)
    console.log('[ws]','[listenerRemoved]','[#'+id+']');
  },
  connectWithSubscribeListener(currentUser, onSubscribe, onPublication, onConnectError=null, channel='personal'){
    this.connect(currentUser, ()=>{
      onSubscribe(this.addSubscribeListener(
          channel,currentUser.id,
          null,
          null, null, null, (m)=>{
            onPublication(m);
          }
      ));
      this.subscribe(channel, currentUser.id, currentUser.token);
    }, ()=>{
      if(onConnectError!==null)
        onConnectError();
    })
  }
}

// /public/cadesplugin_api.js
Vue.prototype.$cryptoPro = {
  getCertificates() {
    // eslint-disable-next-line no-undef
    const plugin = cadesplugin;

    const extractNamePart = (source, prefix) => {
      if (!source || !prefix) {
        return '';
      }
      const begin = source.indexOf(prefix);
      if (begin < 0) {
        return '';
      }
      let end = source.indexOf(', ', begin);
      while (end > 0) {
        const part = source.substring(begin, end);
        const quotesCount = (part.match(/'/g) || []).length;
        if (quotesCount % 2 === 0) {
          break;
        }
        end = source.indexOf(', ', end + 1);
      }
      return (end < 0 ? source.substring(begin) : source.substring(begin, end)).replace(prefix, '');
    };

    const decodeChainStatus = (statusValue) => {
      if (!statusValue) {
        return '';
      }

      const statusRules = [
        [plugin.CERT_TRUST_IS_NOT_TIME_VALID, 'Истек/не наступил срок действия сертификата'],
        [plugin.CERT_TRUST_IS_REVOKED, 'Сертификат отозван'],
        [plugin.CERT_TRUST_IS_NOT_SIGNATURE_VALID, 'Сертификат не имеет действительной подписи'],
        [plugin.CERT_TRUST_IS_NOT_VALID_FOR_USAGE, 'Сертификат не предназначен для такого использования'],
        [plugin.CERT_TRUST_IS_UNTRUSTED_ROOT, 'Нет доверия к корневому сертификату'],
        [plugin.CERT_TRUST_REVOCATION_STATUS_UNKNOWN, 'Статус сертификата неизвестен'],
        [plugin.CERT_TRUST_IS_CYCLIC, 'Кольцевая зависимость для издателей сертификатов'],
        [plugin.CERT_TRUST_INVALID_EXTENSION, 'Одно из расширений сертификата недействительно'],
        [plugin.CERT_TRUST_INVALID_POLICY_CONSTRAINTS, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_INVALID_BASIC_CONSTRAINTS, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_INVALID_NAME_CONSTRAINTS, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_HAS_NOT_SUPPORTED_NAME_CONSTRAINT, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_HAS_NOT_DEFINED_NAME_CONSTRAINT, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_HAS_NOT_PERMITTED_NAME_CONSTRAINT, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_HAS_EXCLUDED_NAME_CONSTRAINT, 'Некорректные ограничения для сертификата'],
        [plugin.CERT_TRUST_IS_OFFLINE_REVOCATION, 'Статус сертификата на отзыв либо устарел, либо проверка производится оффлайн'],
        [plugin.CERT_TRUST_NO_ISSUANCE_CHAIN_POLICY, 'Для цепочки отсутствует требуемая политика выдачи'],
        [plugin.CERT_TRUST_IS_EXPLICIT_DISTRUST, 'Явное недоверие к сертификату'],
        [plugin.CERT_TRUST_HAS_NOT_SUPPORTED_CRITICAL_EXT, 'Сертификат не поддерживает критическое расширение'],
        [plugin.CERT_TRUST_HAS_WEAK_SIGNATURE, 'Использован недостаточно стойкий алгоритм подписи']
      ];

      const messages = statusRules
        .filter(([flag]) => statusValue & flag)
        .map(([, message]) => message);
      return messages.join('; ');
    };

    return new Promise((resolve, reject) => {
      plugin.catch(reject)
      plugin.async_spawn(function* () {
        let store = null;
        try {
          const certificatesData = [];
          store = yield plugin.CreateObjectAsync('CAdESCOM.Store');
          yield store.Open();

          const certificates = yield store.Certificates;
          const count = yield certificates.Count;

          for (let i = 1; i <= count; i += 1) {
            const cert = yield certificates.Item(i);
            const subjectName = yield cert.SubjectName;
            const issuerName = yield cert.IssuerName;
            const validFromDate = yield cert.ValidFromDate;
            const validToDate = yield cert.ValidToDate;
            const thumbprint = yield cert.Thumbprint;
            const hasPrivateKey = yield cert.HasPrivateKey();

            let providerName = '-';
            let privateKeyLink = 'Нет привязки к закрытому ключу';
            if (hasPrivateKey) {
              try {
                const privateKey = yield cert.PrivateKey;
                providerName = yield privateKey.ProviderName;
                privateKeyLink = yield privateKey.UniqueContainerName;
              } catch (e) {
                providerName = '-';
                privateKeyLink = plugin.getLastError(e);
              }
            }

            let publicKeyAlgorithm = '';
            try {
              const publicKey = yield cert.PublicKey();
              const algorithm = yield publicKey.Algorithm;
              publicKeyAlgorithm = yield algorithm.FriendlyName;
            } catch (e) {
              publicKeyAlgorithm = '';
            }

            let certStatus = 'Не действителен';
            let chainForCertificate = '';
            try {
              const validator = yield cert.IsValid();
              const isValid = yield validator.Result;
              if (isValid) {
                certStatus = 'Действителен';
                chainForCertificate = 'Цепочка проверена';
              } else {
                const chainCerts = yield validator.ValidationCertificates;
                const errorStatuses = yield validator.ErrorStatuses;
                const chainCount = yield chainCerts.Count;
                const chainRows = [];
                for (let j = 1; j <= chainCount; j += 1) {
                  const chainCert = yield chainCerts.Item(j);
                  const chainSubjectName = yield chainCert.SubjectName;
                  const chainName = extractNamePart(chainSubjectName, 'CN=') || chainSubjectName;
                  const statusValue = yield errorStatuses.Item(chainCount - j + 1);
                  const statusText = decodeChainStatus(statusValue);
                  chainRows.push(statusText ? `${chainName}: ${statusText}` : chainName);
                }
                chainForCertificate = chainRows.join(' | ');
              }
            } catch (e) {
              certStatus = 'Не действителен';
              chainForCertificate = 'Ошибка при проверке цепочки сертификатов';
            }

            certificatesData.push({
              cert: cert,
              info: {
                'Владелец': extractNamePart(subjectName, 'CN=') || subjectName,
                'Издатель': extractNamePart(issuerName, 'CN=') || issuerName,
                'Выдан': moment(validFromDate).utc().format('DD.MM.YYYY HH:mm:ss'),
                'Истекает': moment(validToDate).utc().format('DD.MM.YYYY HH:mm:ss'),
                'Отпечаток': thumbprint,
                'Криптопровайдер': providerName,
                'Ссылка на закрытый ключ': privateKeyLink,
                'Алгоритм ключа': publicKeyAlgorithm,
                'Статус': certStatus,
                'Цепочка для сертификата': chainForCertificate,
                'Установлен в хранилище': 'Да'
              }
            });
          }

          if (store) {
            yield store.Close();
          }
          resolve(certificatesData);
        } catch (err) {
          try {
            if (store) {
              yield store.Close();
            }
          } catch (closeErr) {
            // ignore close error
          }
          reject(plugin.getLastError(err));
        }
      });
    });
  },
  signCreate(cert, xmlString) {
    // eslint-disable-next-line no-undef
    const plugin = cadesplugin;

    return new Promise(function(resolve, reject) {
      if (Vue.prototype.$tools.isEmpty(xmlString))
        return reject('Нет данных для подписи');

      plugin.async_spawn(function* () {
        try {
          let utf8XmlToBase64 = function(xmlString) {
            const encoder = new TextEncoder();
            const utf8Bytes = encoder.encode(xmlString);
            let binary = '';
            const chunkSize = 0x8000;
            for (let i = 0; i < utf8Bytes.length; i += chunkSize) {
              const sub = utf8Bytes.subarray(i, i + chunkSize);
              binary += String.fromCharCode.apply(null, sub);
            }
            return btoa(binary);
          }

          const contentBase64 = utf8XmlToBase64(xmlString);

          let oSigner = yield plugin.CreateObjectAsync("CAdESCOM.CPSigner");
          yield oSigner.propset_Certificate(cert);
          yield oSigner.propset_Options(
            plugin.CAPICOM_CERTIFICATE_INCLUDE_END_ENTITY_ONLY
          );

          const oSignedData = yield plugin.CreateObjectAsync('CAdESCOM.CadesSignedData');
          yield oSignedData.propset_ContentEncoding(plugin.CADESCOM_BASE64_TO_BINARY);
          yield oSignedData.propset_Content(contentBase64);

          const signature = yield oSignedData.SignCades(
            oSigner,
            plugin.CADESCOM_CADES_BES,
            true, // отсоединённая подпись
            plugin.CADESCOM_ENCODE_BASE64
          );

          resolve(signature.replace(/\s+/g, ''));
        } catch (e) {
          reject(plugin.getLastError(e));
        }
      });

    });
  }
}

Vue.config.productionTip = false


// Окно с подтверждением
let confirmDialogInstance = null;

Vue.prototype.$confirm = function(
  title,
  message,
  confirmCallback,
  rejectCallback = () => {},
  ...callbackArgs
) {
  if (!confirmDialogInstance) {
    const ConfirmComponent = Vue.extend(ConfirmDialog);
    confirmDialogInstance = new ConfirmComponent({
      vuetify
    }).$mount();
    document.body.appendChild(confirmDialogInstance.$el);
  }

  confirmDialogInstance.show(
    title,
    message,
    () => confirmCallback(...callbackArgs),
    () => rejectCallback(...callbackArgs)
  );
};

//сохранение и чтение корзины из localStorage
const STORAGE_KEY = 'misBasket';
function saveBasketToStorage(basket) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(basket));
}
function loadBasketFromStorage() {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
}

window.addEventListener('storage', event => {
  if (event.key === 'misBasket') { // обновление корзины во всех вкладках
    const newBasket = JSON.parse(event.newValue || '[]');
    store.dispatch('setBasket', newBasket)
  }
  if (event.key==='userLogout') { // обновление всех страниц при выходе
    location.reload();
  }
});


const store = new Vuex.Store({
  state: {
    comBranchId: null,
    page:{
      snackbars: [],
    },
    callPhone:null,
    user:null,
    tmp:{},
    basket: loadBasketFromStorage()
  },
  mutations: {
    alertSuccess(state, mess){
      if(typeof mess === 'object'){
        let data = {
          message:mess.message,
          timeout: mess.timeoutSec*1000,
          color:'green',
          right: true,
          bottom: true,
          id:mess.id,
          loading:mess.loading,
        };

        if(Vue.prototype.$tools.isEmpty(mess.id)){
          state.page.snackbars.push(data)
        } else {
          const index = state.page.snackbars.findIndex(obj => obj.id === mess.id);
          if (index === -1) {
            state.page.snackbars.push(data)
          } else {
            Vue.set(state.page.snackbars, index, data);
          }
        }

        Vue.prototype.$tools.storageArrayAdd('notifs', {
          text:mess.message,
          color:'success',
        });
      } else {
        state.page.snackbars.push({
          message:mess,
          timeout: 15000,
          color:'green',
          right: true,
          bottom: true
        });
        Vue.prototype.$tools.storageArrayAdd('notifs', {
          text:mess,
          type:'success',
        });
      }
    },
    alertWarning(state, mess){
      if(typeof mess === 'object'){
        let data = {
          message:mess.message,
          timeout: mess.timeoutSec*1000,
          color:'orange darken-1',
          right: true,
          bottom: true,
          id:mess.id,
          loading:mess.loading,
        };

        if(Vue.prototype.$tools.isEmpty(mess.id)){
          state.page.snackbars.push(data)
        } else {
          const index = state.page.snackbars.findIndex(obj => obj.id === mess.id);
          if (index === -1) {
            state.page.snackbars.push(data)
          } else {
            Vue.set(state.page.snackbars, index, data);
          }
        }

        Vue.prototype.$tools.storageArrayAdd('notifs', {
          text:mess,
          type:'warning',
        });
      } else {
        state.page.snackbars.push({
          message:mess,
          timeout: 15000,
          color:'orange darken-1',
          right: true,
          bottom: true
        })
        Vue.prototype.$tools.storageArrayAdd('notifs', {
          text:mess,
          type:'warning',
        });
      }
    },
    alertError(state, mess){
      if(typeof mess === 'object'){
        let data = {
          message:mess.message,
          timeout: mess.timeoutSec*1000,
          color:'red',
          right: true,
          bottom: true,
          id:mess.id,
          loading:mess.loading,
        };

        if(Vue.prototype.$tools.isEmpty(mess.id)){
          state.page.snackbars.push(data)
        } else {
          const index = state.page.snackbars.findIndex(obj => obj.id === mess.id);
          if (index === -1) {
            state.page.snackbars.push(data)
          } else {
            Vue.set(state.page.snackbars, index, data);
          }
        }

        Vue.prototype.$tools.storageArrayAdd('notifs', {
          text:mess.message,
          type:'error',
        });
      } else {
        state.page.snackbars.push({
          message:mess,
          timeout: 15000,
          color:'red',
          right: true,
          bottom: true
        })
        Vue.prototype.$tools.storageArrayAdd('notifs', {
          text:mess,
          type:'error',
        });
      }
      axios.post('/api/log/',{
        entityName:'clientAlertError',
        entityId: Math.floor(Date.now() / 1000),
        data:[typeof mess === 'object' ? mess.message : mess]
      },{ skipGlobalError: true });
    },
    call(state, phone){
      state.callPhone = phone;
    },
    set_basket(state, newBasket) {
      console.log('newBasket',newBasket);
      state.basket = newBasket;
      saveBasketToStorage(state.basket);
    },
    add_to_basket(state, item) {
      state.basket.push(item);
      saveBasketToStorage(state.basket);
    },
    remove_from_basket(state, item) {
      state.basket = state.basket.filter(i => i.id !== item.id);
      console.log(state.basket)
      saveBasketToStorage(state.basket);
    },
    clear_basket(state) {
      state.basket = [];
      saveBasketToStorage(state.basket);
    }
  },
  actions: {
    setBasket({ commit }, newBasket) {
      commit('set_basket', newBasket);
    },
    addToBasket({ commit }, item) {
      commit('add_to_basket', item);
    },
    removeFromBasket({ commit }, item) {
      commit('remove_from_basket', item);
    },
    clearBasket({ commit }) {
      commit('clear_basket');
    }
  },
  getters: {
    basketItems: state => state.basket,
    basketCount: state => state.basket.length,
    basketTotalPrice: state => state.basket.reduce((sum, item) => sum + Number(item.priceTotal), 0)
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  vuetify,
}).$mount('#app')


